import { Icon, IconProps } from "../";

export const LinkIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M105,575 L102,575 C101.45,575 101,575.45 101,576 C101,576.55 101.45,577 102,577 L105,577 C106.65,577 108,578.35 108,580 C108,581.65 106.65,583 105,583 L102,583 C101.45,583 101,583.45 101,584 C101,584.55 101.45,585 102,585 L105,585 C107.76,585 110,582.76 110,580 C110,577.24 107.76,575 105,575 Z M96,580 C96,580.55 96.45,581 97,581 L103,581 C103.55,581 104,580.55 104,580 C104,579.45 103.55,579 103,579 L97,579 C96.45,579 96,579.45 96,580 Z M98,583 L95,583 C93.35,583 92,581.65 92,580 C92,578.35 93.35,577 95,577 L98,577 C98.55,577 99,576.55 99,576 C99,575.45 98.55,575 98,575 L95,575 C92.24,575 90,577.24 90,580 C90,582.76 92.24,585 95,585 L98,585 C98.55,585 99,584.55 99,584 C99,583.45 98.55,583 98,583 Z"
        transform="translate(-88 -568)"
      />
    </Icon>
  );
};
